/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Text } from 'grommet'
import { Card } from 'grommet-controls'
import { MdTimer } from 'react-icons/md'
import TimerMachine from 'react-timer-machine'
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

class CardTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = { go: true}
  }

  componentDidMount() {
    this.setState({go: true})
  }

  render() {
    let message;
    console.log("props : ", this.props)
    if (this.props.static) {
      //message = moment.duration(this.props.minutes, "minutes").format("hh[h]mm")
      message = moment.duration(this.props.time, 'milliseconds').format("hh[h]mm")
    }
    else {
      let time = this.props.time / 60000
      console.log("time : ", time)
      message = (
        <TimerMachine
          timeStart={0} // start at 10 min
          timeEnd={time} // end at xx min
          started={this.state.go}
          paused={false}
          countdown={false} // use as stopwatch
          interval={10} // tick every 1 min
          formatTimer={(time, tt) =>
            moment.duration(tt, "minutes").format("hh[h]mm")
          }
        />
      )
    }

    console.log("CardTime time : ", this.props.time)
    return(
      <Card 
        background='brand'
        basis='small'
        size={{ width: 'small', height: 'small' }}
      >         
        <Card.CardTitle align='center'>
          <MdTimer size='3em'/>
          <Text size='xlarge'>Temps</Text>
        </Card.CardTitle>
        <Card.CardContent align='center'>
          <Text size='xxlarge'>
            { message }
          </Text>
        </Card.CardContent>
      </Card>
    )
  }
}

export default CardTime
